import { Rocket, MapPin, Calendar, Target } from "lucide-react";

export const LaunchInfoGrid = ({ launch, formattedDate }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
      <div className="p-2 rounded-lg bg-cosmic-blue/20">
        <Rocket className="w-5 h-5 text-cosmic-blue" strokeWidth={1.5} />
      </div>
      <div>
        <p className="text-xs text-slate-500 uppercase tracking-wider">Rocket</p>
        <p className="text-white font-semibold">{launch.rocket_full_name || launch.rocket}</p>
      </div>
    </div>

    <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
      <div className="p-2 rounded-lg bg-ignition-red/20">
        <MapPin className="w-5 h-5 text-ignition-red" strokeWidth={1.5} />
      </div>
      <div>
        <p className="text-xs text-slate-500 uppercase tracking-wider">Location</p>
        <p className="text-white font-semibold">{launch.pad_name}</p>
      </div>
    </div>

    <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
      <div className="p-2 rounded-lg bg-space-gold/20">
        <Calendar className="w-5 h-5 text-space-gold" strokeWidth={1.5} />
      </div>
      <div>
        <p className="text-xs text-slate-500 uppercase tracking-wider">Launch Time</p>
        <p className="text-white font-semibold text-sm">{formattedDate}</p>
      </div>
    </div>

    {launch.orbit && (
      <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
        <div className="p-2 rounded-lg bg-purple-500/20">
          <Target className="w-5 h-5 text-purple-400" strokeWidth={1.5} />
        </div>
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wider">Orbit</p>
          <p className="text-white font-semibold">{launch.orbit}</p>
        </div>
      </div>
    )}
  </div>
);
